import { GoHighLevelBlogSelect } from '../GoHighLevelBlogSelect/GoHighLevelBlogSelect'
import { GoHighLevelAuthorSelect } from '../GoHighLevelAuthorSelect/GoHighLevelAuthorSelect'
import {
  BlogMetadataIntegrationState,
  BlogMetadataIntegrationHandlers,
} from '../../../hooks/useBlogMetadataIntegration'
import { Text } from 'blaze-ui/Text/Text'
import Styles from '../../../BlogMetadata.module.scss'

interface GoHighLevelIntegrationFieldsProps {
  integrationState: BlogMetadataIntegrationState
  handlers: BlogMetadataIntegrationHandlers
  isPostPublished: boolean
}

export const GoHighLevelIntegrationFields: React.FC<GoHighLevelIntegrationFieldsProps> = ({
  integrationState,
  handlers,
  isPostPublished,
}) => {
  const { selectedBlogId, selectedAuthorId, availableBlogs, availableAuthors } = integrationState
  const { handleBlogSelect, handleAuthorSelect } = handlers

  const hasOptions = availableBlogs.length > 0 && availableAuthors.length > 0

  if (!hasOptions) {
    return (
      <Text color="var(--red-70)">
        No blogs or authors were found in your GoHighLevel account. Create them in GoHighLevel, then return here and
        refresh your integration.
      </Text>
    )
  }

  return (
    <>
      <div className={Styles.categoryDropdownContainer}>
        <label className={Styles.textFieldLabel}>Blog</label>
        <div className={Styles.categoryDropdown}>
          <GoHighLevelBlogSelect
            blogs={availableBlogs}
            selectedBlogId={selectedBlogId}
            onBlogSelect={handleBlogSelect}
            disabled={isPostPublished}
          />
        </div>
      </div>

      <div className={Styles.categoryDropdownContainer}>
        <label className={Styles.textFieldLabel}>Author</label>
        <div className={Styles.categoryDropdown}>
          <GoHighLevelAuthorSelect
            authors={availableAuthors}
            selectedAuthorId={selectedAuthorId}
            onAuthorSelect={handleAuthorSelect}
            disabled={isPostPublished}
          />
        </div>
      </div>
    </>
  )
}
